export const HelpLinks = {
  login: 'https://help.bell-face.com/categories/675bf5af449dc408d527d573/',
  systemRequirements:
    'https://faq.bell-face.com/%E3%83%9B%E3%82%B9%E3%83%88%E5%81%B4_%E5%8B%95%E4%BD%9C%E7%92%B0%E5%A2%83-5e65b2664a7a7c00170acfb0',
  chatSupport: 'https://help.bell-face.com/',
  passwordReset: 'https://help.bell-face.com/faqs/67692dc218ecfdf7b055489c/',
  register: 'https://help.bell-face.com/',
} as const
